import { useNavigate } from "react-router-dom";
import Data from "../Data/Data";
import "./Menu.css"

const Menu = () =>{
    const data= Data
    const navigate = useNavigate()
    return(
        <div className="menu-container">
            <img className="logo" src={require("../assets/logo.png")} alt="Hacienda de Los Morales"/>
            <img className="menu-principal" src={require("../assets/menu.png")} alt="Menu Principal"/>
            {data.map(d=> <div className="option-container" onClick={()=>{navigate(`/${d.url}`)}}>
                <span className="option" dangerouslySetInnerHTML={{__html:d.name}}></span>
                <span className="english-option">{d.english_name}</span>
                {d.date && <span className="option">{d.date}</span>}
            </div>)}
        </div>
    )
}

export default Menu;